import React from 'react';
import data from './data'
import Scrollspy from 'react-scrollspy'
import Nav from './Nav'
import './floating-nav.css'

const FloatingNav = () => {
  return (
    <ul id="floating__nav" data-aos="fade-up">
      <Scrollspy offset={-470} className='scrollspy' items={['header', 'about', 'services', 'portfolio', 'contact']} currentClassName="active">
        {
          data.map(item => <Nav key={item.id} item={item} />)
        }
      </Scrollspy>
    </ul>
  )
}

export default FloatingNav